import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const getExportQuery = gql`
  query GetExport($exportId: ID!) {
    getExport(exportId: $exportId) {
      exportId
      status
      progressPercent
      downloadUrl
      error
    }
  }
`

export const getExportKey = getQueryNames(getExportQuery)[0]

export {getExportQuery}
